<!-- Content -->
<div
  mat-dialog-content
  class="modal-body modal-body-edit-fields kultur-nav-fields-container"
>
  <div class="modal-main-content">
    <!-- SEARCH -->
    <form class="kultur-nav-fields__search-field ">
      <mat-form-field appearance="outline">
        <input
          matInput
          [(ngModel)]="search"
          name="search"
          placeholder="{{'TRANS__CULTURE_HUB_IMPORTER__SEARCH_PLACEHOLDER' | translate}}"
        >

        <mat-icon
          matPrefix
          color="accent"
        >
          search
        </mat-icon>
      </mat-form-field>
    </form>

    <!-- TABLE -->
    <div class="kultur-nav-table-container">
      <div class="md-table admin-scroll-layout kultur-nav-table">
        <table
          (matSortChange)="sortData($event)"
          [dataSource]="sortedDataSource | KulturNavFolderFilter: search"
          mat-table
          matSort
        >
          <!-- Selected Checkbox -->
          <ng-container matColumnDef="selected">
            <th
              mat-header-cell
              *matHeaderCellDef mat-sort-header=""
            ></th>

            <td
              mat-cell
              *matCellDef="let folder"
            >
              <mat-checkbox
                [checked]="selectedMap.has(folder.artifact_id)"
                (change)="selectFolder(folder)"
              ></mat-checkbox>
            </td>
          </ng-container>

          <!-- Folder Name, on click open a new tab to kulturnav.org/${folder.uuid} -->
          <ng-container matColumnDef="folderName">
            <th
              mat-header-cell
              *matHeaderCellDef mat-sort-header=""
            >
              <span>
                {{ 'TRANS__CULTURE_HUB_IMPORTER__FOLDER_NAME' | translate }}
              </span>
            </th>

            <td
              mat-cell
              *matCellDef="let folder"
            >
              <a
                href="https://kulturnav.org/{{folder.uuid}}"
                target="_blank"
              >
                {{folder.name?.name}}
              </a>
            </td>
          </ng-container>

          <!-- Local Name -->
          <ng-container matColumnDef="remoteListName">
            <th
              mat-header-cell
              *matHeaderCellDef mat-sort-header=""
            >
              <span>
                {{ 'TRANS__CULTURE_HUB_IMPORTER__LOCAL_NAME' | translate }}
              </span>
            </th>

            <td
              mat-cell
              *matCellDef="let folder"
            >
              {{folder.remote_list.remote_list_name}}
            </td>
          </ng-container>

          <!-- Source Updated Date -->
          <ng-container matColumnDef="sourceUpdatedAt">
            <th
              mat-header-cell
              *matHeaderCellDef mat-sort-header=""
            >
              <span>
                {{ 'TRANS__CULTURE_HUB_IMPORTER__SOURCE_UPDATED_AT' | translate }}
              </span>
            </th>

            <td
              mat-cell
              *matCellDef="let folder"
            >
              {{getDateFromIso(folder.source_updated_at)}}
            </td>
          </ng-container>

          <!-- Updated -->
          <ng-container matColumnDef="updated">
            <th
              mat-header-cell
              *matHeaderCellDef mat-sort-header=""
            >
              <span>
                {{ 'TRANS__CULTURE_HUB_IMPORTER__UPDATED' | translate }}
              </span>
            </th>

            <td
              mat-cell
              *matCellDef="let folder"
              style="text-align: center; vertical-align: middle"
            >
              <mat-checkbox
                [ngModel]="!!folder.imported_date"
                (ngModelChange)="folder.imported_date = $event" disabled
              ></mat-checkbox>
            </td>
          </ng-container>

          <!-- Local Updated Date -->
          <ng-container matColumnDef="localUpdatedAt">
            <th
              mat-header-cell
              *matHeaderCellDef mat-sort-header=""
            >
              <span>
                {{ 'TRANS__CULTURE_HUB_IMPORTER__LOCAL_UPDATED_AT' | translate }}
              </span>
            </th>

            <td
              mat-cell
              *matCellDef="let folder"
              [ngClass]="{'expired': isBefore(folder)}"
            >
              {{getDateFromIso(folder.imported_date)}}
            </td>
          </ng-container>

          <!-- Owner Type Name -->
          <ng-container matColumnDef="ownerType">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header=""
            >
              <span>
                {{ 'TRANS__CULTURE_HUB_IMPORTER__OWNER_TYPE' | translate }}
              </span>
            </th>

            <td
              mat-cell
              *matCellDef="let folder"
            >
              {{folder.folder_type.folder_type_id_value}}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="mat-row kultur-nav-table__no-data" *matNoDataRow>
            <td class="mat-cell" colspan="7">
              @if (!sortedDataSource?.length) {
                <!-- SEARCHING -->
                @if (importing) {
                  <span class="kultur-nav-table__no-data-spinner">
                    <mat-spinner
                      color="accent"
                      diameter="16"
                    ></mat-spinner>

                    <span class="kultur-nav-table__no-data-spinner-text">
                      {{ 'TRANS__CULTURE_HUB_IMPORTER__LOADING' | translate }}
                    </span>
                  </span>
                }
                @else {
                  <!-- NO OPTIONS AVAILABLE -->
                  <span class="tone-down-color">
                    {{ 'TRANS__CULTURE_HUB_IMPORTER__NO_AVAILABLE_OPTIONS' | translate }}
                  </span>
                }
              }
              @else if (sortedDataSource?.length > 0 && !(sortedDataSource | KulturNavFolderFilter: search)?.length > 0) {
                <!-- NO HITS ON SEARCH -->
                <span class="tone-down-color">
                  {{ 'TRANS__CULTURE_HUB_IMPORTER__NO_SEARCH_HITS' | translate }}
                </span>
              }
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- CHIPS -->
    <div class="kultur-nav-fields__selected-terms">
      <span class="bold">
        {{ 'TRANS__MODAL_DIALOG__YOU_HAVE_CHOSEN' | translate }}
      </span>

      @if (selectedMap.size > 0) {
        <mat-chip-listbox>
          @for (selected of selectedMap | keyvalue; track $index) {
            <mat-chip-option (removed)="selectFolder(selected.value)">
              {{selected.value.name.name}}

              <mat-icon matChipRemove>
                cancel
              </mat-icon>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      }
    </div>
  </div>
</div>

<!-- Culture Hub Footer -->
<div
  mat-dialog-actions
  class="modal-footer dialog-border-color kultur-nav-footer-container"
>
  <span class="kultur-nav-footer-container__feedback">
    @for (error of errors; track $index) {
      <ng-container>
        @if (errors.length) {
          <span class="error-warn-color bold">
            {{ error | translate }}
          </span>
        }
      </ng-container>
    }
  </span>

  <button
    mat-flat-button
    [disabled]="importing || !selectedMap.size"
    color="accent"
    type="submit"
    (click)="runImport()"
  >
    @if (!importing) {
      <span class="bold">
        {{ 'TRANS__CULTURE_HUB_IMPORTER__IMPORT_FOLDERS' | translate }}
      </span>
    }
    @else {
      <span class="kultur-nav-footer-container__downloading">
        <mat-spinner
          diameter="16"
          id="kultur-nav-downloading"
        ></mat-spinner>

        <span class="bold">
          {{ 'TRANS__CULTURE_HUB_SEARCH__IMPORTING' | translate }}
        </span>
      </span>
    }
  </button>

  <button
    mat-button
    type="button"
    color="accent"
    (click)="closeImport()"
  >
    <span class="bold">
      {{ 'TRANS__BUTTON__CLOSE' | translate }}
    </span>
  </button>

  <!-- Progressbar -->
  @if (progress) {
    <div
      class="row"
      style="margin-top: 8px"
    >
      <mat-progress-bar
        color="accent"
        [value]="progress">
      </mat-progress-bar>
    </div>
  }
</div>
